// extracted by mini-css-extract-plugin
export default {"container":"ban_2-rmF","logoContainer":"ban_log_2ORsj","logo":"ban_log_O0sQL","presentedBy":"ban_pre_3sar4"};